import { toast } from "react-toastify"
export function toastError(content) {
  return function (dispatch) {
    dispatch({
      type: "RaiseError",
    })
    toast.error(content)
  }
}
